import React, { useContext, useState } from "react";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import {
  Segment,
  Modal,
  Button,
  Header,
  Grid,
  Form,
  Input,
  Checkbox,
  Icon,
  Pagination,
  Divider,
  Select,
  Dropdown as DropdownSemantic,
  Breadcrumb,
} from "semantic-ui-react";
import {
  Table,
  Dropdown as DropdownAnt,
  Menu,
  Empty,
  Radio as RadioAnt,
  Form as FormAnt,
  Popover,
  Image,
} from "antd";
import "semantic-ui-css/semantic.min.css";
import "../old.scss";
import { HomeFilled } from "@ant-design/icons";
import {
  AreaOptions,
  EntidadOptions,
  LineaEstrategicaOptions,
  EstadosOptions,
} from "../../../../utils/dataSelectOptions";
import {
  cambiarPestaña,
  edicionConvocatoria,
  idConvocatorias,
} from "../../../../redux/actions/convocatoriaAction";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ModalVisualizar } from "../../ModalVisualizar/ModalVisualizar";
import { TemplateContext } from "../../../../utils/template_context";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import { generarAnios } from "../../../../utils/generateYears";
import apiMaestras from "../../../../api/Maestras/api-maestras";

const cantidadRegistros = [
  { key: 1, value: 10, text: "10" },
  { key: 2, value: 20, text: "20" },
  { key: 3, value: 50, text: "50" },
  { key: 4, value: 100, text: "100" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En proceso": "#EFC236",
  Cerrada: "#9F0505",
};
const tiposidentificacion = [
  { key: 3, value: 3, text: "Persona natural" },
  { key: 2, value: 2, text: "Persona jurídica" },
  { key: 1, value: 1, text: "Grupo conformado" },
];

export const AdminConvocatorias = () => {  
  const history = useNavigate();
  const dispatch = useDispatch();
  const { decrypt, encrypt } = useEncrypt();
  const context = useContext(TemplateContext);
  const [years, setYears] = useState([]);
  let fechaActual = moment()

  const generateOptionsYears = () => {
    let arrayYears = [];
    const years = generarAnios();

    if (years.length > 0) {
      years.map((year, i) => { arrayYears.push({ key: i, value: year, text: year }) });
    }

    setYears(arrayYears);
  }

  //  DATOS QUE VAN HACER MOSTRADOS EN LA TABLA
  React.useEffect(() => {
    getUser();
    generateOptionsYears();
    primeroDatostabla();
    getLineasConvocatorias();
  }, []);
  const initialState = {
    datossinfiltro: [],
  };
  const initialValuesBuscarConvocatoria = {
    area: "",
    entidad: "",
    linea: "",
    tipo_participante: "",
    estado: "",
    anio: null
  };
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [datosActuales, setDatosActuales] = React.useState([]);
  const [principalState, setPrincipalState] = React.useState(initialState);
  const [paginacionActual, setPaginacionActual] = React.useState(1);
  const [paginacionTotal, setPaginacionTotal] = React.useState(0);
  const [cantidadPáginas, setCantidadPáginas] = React.useState(10);
  const [filtroAvanzado, setFiltroAvanzado] = React.useState(false);
  const [openModalBorrar, setOpenModalBorrar] = React.useState(false);
  const [nombreBorrar, setNombreBorrrar] = React.useState("");
  const [idBorrar, setIdBorrrar] = React.useState("");
  const [user, setUser] =  React.useState({});

  const [buscarconvocatoria, setBucarConvocatoria] = React.useState(
    initialValuesBuscarConvocatoria
  );

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
    else return "";
  }

  const excluirEntidades = ['SM', 'MCM', 'PP', 'AGENDA CULTURAL'];
  const eventos = ['AGENDA CULTURAL'];


  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  const menu = (datos) => {
    return (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => abrirEditar("infoconvocatoria", datos)}
        >
          Información general
        </Menu.Item>
        <Menu.Item key="2" onClick={() => abrirEditar("cronograma", datos)}>
          Cronograma
        </Menu.Item>
        <Menu.Item key="3" onClick={() => abrirEditar("documentos", datos)}>
          Doc. administrativos
        </Menu.Item>
        <Menu.Item
          key="4"
          onClick={() => abrirEditar("documentacionTecnica", datos)}
        >
          Doc. técnicos
        </Menu.Item>
        <Menu.Item
          key="5"
          onClick={() => abrirEditar("documentacionConvocatoria", datos)}
        >
          Doc. general
        </Menu.Item>
      </Menu>
    );
  };
  const menubeps = (datos) => {
    return (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => abrirEditar("infoconvocatoria", datos, "1")}
        >
          Información general
        </Menu.Item>
        <Menu.Item
          key="2"
          onClick={() => abrirEditar("cronograma", datos, "2")}
        >
          Cronograma
        </Menu.Item>
        <Menu.Item
          key="3"
          onClick={() => abrirEditar("documentacionConvocatoria", datos, "3")}
        >
          Doc. general
        </Menu.Item>
      </Menu>
    );
  };
  const menujurados = (datos) => {
    return (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => abrirEditar("infoconvocatoria", datos, "1")}
        >
          Información general
        </Menu.Item>
        <Menu.Item
          key="2"
          onClick={() => abrirEditar("cronograma", datos, "2")}
        >
          Cronograma
        </Menu.Item>
        <Menu.Item
          key="3"
          onClick={() => abrirEditar("documentacionConvocatoria", datos, "3")}
        >
          Doc. general
        </Menu.Item>
      </Menu>
    );
  };
  const menucrear = () => {
    return (
      <Menu>
        <Menu.Item key="1" onClick={consultarconvocatioria}>
          Convocatoria General
        </Menu.Item>
        <Menu.Item key="2" onClick={consultarconvocatoriabeps}>
          BEPS
        </Menu.Item>
        <Menu.Item key="3" onClick={consultarconvocatoriajurados}>
          Jurados
        </Menu.Item>
      </Menu>
    );
  };
  // routes
  const routes = [
    { nombre: "Convocatorias" },
    { nombre: "Tablero de Convocatorias" },
  ];
  const columns = [
    {
      title: "No.",
      width: 60,
      render: (datos, datos2, index) => {
        return (
          <span className="font-family-Montserrat-Regular">{datos.idconvocatorias}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Línea Convocatoria",
      width: 500,
      render: (datos) => {
          return (
              <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line",  fontWeight: "bold"}}>
                {getFilterLineaConvocatoria(datos?.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria)}` : ""}
              </span>
          );
      }
    },
    {
      title: "Nombre",
      width: 200,
      dataIndex: "nombre_convocatoria",
      key: "name",
      render: (datos) => {
        return (
          datos &&
          (datos.length > 27 ? (
            <Popover content={datos} title="Nombre Convocatoria">
              <span
                style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
              >{`${datos.substring(0, 20)}...`}</span>
            </Popover>
          ) : (
            datos
          ))
        );
      },
    },
    {
      title: "Código",
      width: 100,
      render: (datos) => (
        <>
          <span className="font-family-Montserrat-Regular">
            {datos.seq_artista && <>{datos.seq_artista}</>}
            {datos.seq_beps && <>{datos.seq_beps}</>}
            {datos.seq_jurado && <>{datos.seq_jurado}</>}
          </span>
        </>
      ),
    },
    {
      title: "Fecha inicio",
      width: 100,
      render: (datos) => {
        let fecha = datos.fecha_creacion;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = new Date(fecha);
            cierreAct.setHours(cierreAct.getHours() - 1);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              var estadoAct = 'Cerrada'
            } else {
              estadoAct = datos.estado
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: () => "Publicada",
      width: 150,
      render: (datos, datos2, index) => (
        <>
          <RadioAnt.Group
            value={datos.publico}
            onChange={(e) => {
              apiConvocatorias.cambiarestadoPublicoConvocatorias(
                datos.idconvocatorias,
                e.target.value
              );
              let infoupdate = [...datosActuales];
              let fechaactual = moment().format("YYYY-MM-DD");
              infoupdate[index].publico = e.target.value;
              datos.publico = e.target.value;
              for (var i in infoupdate) {
                for (var y in infoupdate[i].fechas) {
                  if (
                    infoupdate[i].fechas[y].clave === "Apertura" &&
                    moment(fechaactual).isBefore(
                      infoupdate[i].fechas[y].valormin.substring(0, 10)
                    )
                  ) {
                    infoupdate[i].estado = "En espera";
                  }
                  if (
                    infoupdate[i].fechas[y].clave === "Apertura" &&
                    moment(fechaactual).isSameOrAfter(
                      infoupdate[i].fechas[y].valormin.substring(0, 10)
                    )
                  ) {
                    infoupdate[i].estado = "Abierta";
                  }
                  if (
                    infoupdate[i].fechas[y].clave === "Cierre" &&
                    moment(fechaactual).isSameOrAfter(
                      infoupdate[i].fechas[y].valormin.substring(0, 10)
                    )
                  ) {
                    infoupdate[i].estado = "Cerrada";
                  }
                  if (
                    infoupdate[i].fechas[y].clave ===
                    "Resolución de otorgamiento" &&
                    moment(fechaactual).isSameOrAfter(
                      infoupdate[i].fechas[y].valormin.substring(0, 10)
                    )
                  ) {
                    infoupdate[i].estado = "Cerrada";
                  }
                  if (!infoupdate[i].publico) {
                    infoupdate[i].estado = "No publicada";
                  }
                }
              }
              return setDatosActuales(infoupdate);
            }}
          >
            <RadioAnt value={true}>Sí</RadioAnt>
            <RadioAnt value={false}>No</RadioAnt>
          </RadioAnt.Group>
        </>
      ),
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Línea estratégica",
      width: 200,
      dataIndex: "linea_estrategica",
      key: "linea_estrategica",
      render: (datos) => {
        return (
          datos &&
          (datos.length > 27 ? (
            <Popover content={datos} title="Línea estratégica">
              <span
                style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
              >{`${datos.substring(0, 26)}...`}</span>
            </Popover>
          ) : (
            datos
          ))
        );
      },
    },
    {
      title: "Creado por",
      width: 220,
      dataIndex: "usuario_creacion",
      key: "usuario_creacion",
    },
    {
      title: () => (
        <div>
          <div className="titleAcciones">Acciones</div>
          <div className="controls">
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Ver
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Editar
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Borrar
            </div>
          </div>
        </div>
      ),
      width: 100,
      key: "operations",
      fixed: context.device === "lg" ? "right" : false,
      render: (datos) => (
        <div className="controls">
          <Button
            className="botones-acciones"
            icon="eye"
            onClick={() => openVisualizar(datos)}
          />
          {datos.tipo === 1 ? (
            <DropdownAnt.Button
              onClick={(e) => abrirEditar("cronograma", datos)}
              overlay={() => menu(datos)}
              className="button-ant-ant"
              icon={<Icon name="pencil" />}
            />
          ) : datos.tipo === 2 ? (
            <DropdownAnt.Button
              onClick={(e) => abrirEditar("cronograma", datos)}
              overlay={() => menujurados(datos)}
              className="button-ant-ant"
              icon={<Icon name="pencil" />}
            />
          ) : datos.tipo === 3 ? (
            <DropdownAnt.Button
              onClick={(e) => abrirEditar("cronograma", datos)}
              overlay={() => menubeps(datos)}
              className="button-ant-ant"
              icon={<Icon name="pencil" />}
            />
          ) : null}
          <Button
            className="botones-acciones boton-borrar-adminconvocatorias"
            icon="trash alternate outline"
            onClick={(e) => abrirmodalEliminar(e, datos)}
          />
        </div>
      ),
    },
  ];
  const [openModal, setOpenModal] = useState(false);
  const [convocatoria, setConvocatoria] = useState({});
  const openVisualizar = (datos) => {
    setConvocatoria(datos);
    setOpenModal(true);
  };
  const primeroDatostabla = async () => {
    try {
      const token = localStorage.getItem('token')
      let response = await axios.get(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/`,
        {
          headers: {
            'Authorization': token
          }
        }
      );
      let fechaactual = moment()
      
      response.data.convocatorias = response.data.convocatorias.filter(
        (data) => data.activo !== false
      );

      for (var i in response.data.convocatorias) {
        if (response.data.convocatorias[i].fechas !== null) {
          let fechas = response.data.convocatorias[i].fechas.sort((a, b) => moment(a.valormin) - moment(b.valormin));

          for (var y in fechas) {
            let fechavalida =
              moment(fechas[y].valormax).isValid() ?
                moment(fechas[y].valormax) :
                moment(fechas[y].valormin);
            if (
              fechas[y].clave === "Apertura" &&
              moment(fechaactual).isBefore(moment(fechas[y].valormin))
            ) {
              response.data.convocatorias[i].estado = "En espera";
            }
            if (
              fechas[y].clave === "Apertura" &&
              moment(fechaactual).isSameOrAfter(moment(fechas[y].valormin))
            ) {
              response.data.convocatorias[i].estado = "Abierta";
            }
            if (
              fechas[y].clave === "Cierre" &&
              moment(fechaactual).isSameOrAfter(fechavalida)
            ) {
              response.data.convocatorias[i].estado = "Cerrada";
            }
            if (
              fechas[y].clave ===
              "Resolución de otorgamiento" &&
              moment(fechaactual).isSameOrAfter(fechavalida)
            ) {
              response.data.convocatorias[i].estado = "Cerrada";
            }
            if (!response.data.convocatorias[i].publico) {
              response.data.convocatorias[i].estado = "No publicada";
            }
          }
        }
      }
      
      if (response.data.convocatorias.length > 0) {
        setPrincipalState({ datossinfiltro: response.data.convocatorias });
        let copy = response.data.convocatorias.map((data) => data);
        let datos = copy.slice(0, cantidadPáginas);
        setDatosActuales(copy);
        let x = response.data.convocatorias.length / cantidadPáginas;
        x = Math.ceil(x);
        return setPaginacionTotal(x);
      }
      let datos = [];
      setDatosActuales(datos);
      setPrincipalState({ datossinfiltro: datos });
      let x = 1;
      x = Math.ceil(x);
      return setPaginacionTotal(x);
    } catch (error) {
      return console.error(error);
    }
  };
  function mostrarConvocatorias(event, value) {
    return setCantidadPáginas(value);
  }
  function filtradodeinformacion(e) {
    let filtrado = principalState.datossinfiltro.filter(
      (data) =>
          getFilterLineaConvocatoria(data.linea_convocatoria)
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
    );
    let datos = filtrado;
    setDatosActuales(datos);
    return setCantidadPáginas(10);
  }
  function abrirmodalEliminar(e, value) {
    setNombreBorrrar(value.numero_convocatoria);
    setIdBorrrar(value.idconvocatorias);
    return setOpenModalBorrar(!openModalBorrar);
  }
  async function borrarConvocatoria() {
    const token = localStorage.getItem('token');

    try {
      await axios.put(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/cambiarEstadoConvocatoria/${idBorrar}`,
        {
          activo: false,
        },
        {
          headers: {
            'Authorization': token
          }
        }
      );
      let copy = datosActuales.map((data) => data);
      let eliminar = copy.filter((data) => data.idconvocatorias !== idBorrar);
      setDatosActuales(eliminar);
      return setOpenModalBorrar(!openModalBorrar);
    } catch (error) {
      console.error(error);
      return;
    }
  }
  function abrirEditar(route, datos, pestaña) {
    dispatch(edicionConvocatoria(true));
    dispatch(idConvocatorias(datos.idconvocatorias));
    localStorage.setItem(
      "id_convocatoria",
      encrypt(datos.idconvocatorias.toString())
    );
    localStorage.setItem("editar_convocatoria", encrypt("true"));
    if (datos.tipo === 1) {
      return history(`/Administrador/${route}`);
    }
    if (datos.tipo === 2) {
      localStorage.setItem("cambiarPestaña", encrypt(pestaña));
      return history(`/Administrador/infoJurados`);
    }
    if (datos.tipo === 3) {
      localStorage.setItem("cambiarPestaña", encrypt(pestaña));
      return history(`/Administrador/infoBeps`);
    }
    return history(`/Administrador/${route}`);
  }

  const consultarconvocatioria = async () => {
    localStorage.removeItem("editar_convocatoria");
    history("/administrador/infoconvocatoria");
  };
  const consultarconvocatoriajurados = async () => {
    localStorage.removeItem("editar_convocatoria");
    history("/administrador/infoJurados");
  };
  const consultarconvocatoriabeps = async () => {
    localStorage.removeItem("editar_convocatoria");
    history("/administrador/infoBeps");
  };
  const filtrarTablaMultiple = (data) => {
    let filtrado = [];
    if (data.value.length === 0) {
      let copy = principalState.datossinfiltro.map((data) => data);
      let datos = copy.slice(0, cantidadPáginas);
      setDatosActuales(datos);
      let x = principalState.datossinfiltro.length / cantidadPáginas;
      x = Math.ceil(x);
      return setPaginacionTotal(x);
    }
    for (var i in datosActuales) {
      if (typeof datosActuales[i][data.input] === "object") {
        if (datosActuales[i][data.input]) {
          for (var x in datosActuales[i][data.input]) {
            for (var y in data.value) {
              if (datosActuales[i][data.input][x].value === data.value[y])
                filtrado.push(datosActuales[i]);
            }
          }
        }
      } else {
        for (var y2 in data.value) {
          if (datosActuales[i][data.input] === data.value[y2])
            filtrado.push(datosActuales[i]);
        }
      }
    }
    let copy = filtrado.map((data) => data);
    let datos = copy.slice(0, cantidadPáginas);
    setDatosActuales(datos);
    let z = filtrado.length / cantidadPáginas;
    z = Math.ceil(z);
    return setPaginacionTotal(z);
  };
  const cambiarFiltro = (e) => {
    return setBucarConvocatoria({
      ...buscarconvocatoria,
      [e.input]: e.value,
    });
  };
  const limpiarFiltros = () => {
    setBucarConvocatoria(initialValuesBuscarConvocatoria);
    return setDatosActuales(principalState.datossinfiltro);
  };
  const filtrarConvocatorias = () => {
    let filtro = principalState.datossinfiltro;
    if (
      buscarconvocatoria.tipo_participante &&
      buscarconvocatoria.tipo_participante !== ""
    ) {
      filtro = filtro.filter((x) => {
        for (var i in x.tipo_participante) {
          if (
            x.tipo_participante[i].value ===
            buscarconvocatoria.tipo_participante
          ) {
            return x;
          }
        }
      });
    }
    if (buscarconvocatoria.area && buscarconvocatoria.area !== "") {
      filtro = filtro.filter((x) => {
        for (var i in x.area) {
          if (x.area[i].value === buscarconvocatoria.area) {
            return x;
          }
        }
      });
    }
    if (buscarconvocatoria.linea && buscarconvocatoria.linea !== "") {
      filtro = filtro.filter(
        (x) => x.linea_estrategica === buscarconvocatoria.linea
      );
    }
    if (buscarconvocatoria.estado && buscarconvocatoria.estado !== "") {
      filtro = filtro.filter((x) => x.estado === buscarconvocatoria.estado);
    }
    if (buscarconvocatoria.entidad && buscarconvocatoria.entidad !== "") {
      filtro = filtro.filter((x) => x.entidad === buscarconvocatoria.entidad);
    }
    if (
      buscarconvocatoria.anio &&
      buscarconvocatoria.anio !== null
    ) {
      filtro = filtro.filter((x) => {
        for (var i in x.fecha_creacion) {
          if (
            moment(x.fecha_creacion).format('YYYY') ===
            String(buscarconvocatoria.anio)
          ) {
            return x;
          }
        }
      });
    }
    return setDatosActuales(filtro);
  };
  function itemRenderTable(current, type, originalElement) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  }

  return (
    <div className="background-color-F7FBFF height-100">
      <div className="col-12 background-color-101c31 ">
        <BreadCrumbAdmin routes={routes} />
      </div>

      <div className="container-fluid ps-md-4 pe-md-4 main-c2">
        <div className="d-flex title_out_card  justify-content-between pe-0">
          <div className="font-family-Montserrat-SemiBold font-size-14px">
            Gestionar convocatorias
          </div>
          <div
            className="container-pagination-adminconvocatorias justify-content-flex-end 
   "
          >
            <DropdownAnt overlay={menucrear} placement="bottomRight">
              <Button
                className="no-margin text-nowrap button-azul-ghost tamaño-botton-admin-convocatoria justify-content-flex-end Custom-ul-li"
                style={{
                  padding: "0",
                  textAlign: "right !important",

                }}
              >
                Crear convocatoria
                <Icon
                  className="padding-left-icono-admin-convocatoria ms-2 me-md-0"
                  size="large"
                  name="plus circle"
                />
              </Button>
            </DropdownAnt>
          </div>
        </div>

        <div className="sombra_card" style={{ marginBottom: "50px" }}>
          <div className="header_card">
            <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
              {" "}
              Lista de Convocatorias{" "}
              <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828"></span>
            </div>
          </div>
          <div className="body_card">
            <div className="row">
              <div className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular">
                <div className="row g-2">
                  <div className="col-11 align-items-center align-content-center pb-3">
                    <Input
                      icon="search"
                      placeholder="Buscar Nombre/Código"
                      className="font-family-Work-Sans font-size-14px border-color-707070 border-radius-5px font-color-051923bf"
                      fluid
                      onChange={filtradodeinformacion}
                    />
                  </div>
                  <div className="col-1 align-items-center justify-content-flex-center">
                    <Button
                      icon="filter"
                      className="button-filtro-adminconvocatorias"
                      onClick={() => setFiltroAvanzado(!filtroAvanzado)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                <div className="d-flex justify-content-end">
                  <div>
                    Total:{" "}
                    <span className="font-color-F28C02">
                      {datosActuales.length}
                    </span>
                  </div>
                </div>

                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </label>
                  <DropdownSemantic
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPáginas}
                    options={cantidadRegistros}
                    icon={
                      <Icon
                        className="font-color-051923bf iconos-dropdown-global"
                        name="angle down"
                      />
                    }
                    onChange={(e, { value }) => mostrarConvocatorias(e, value)}
                  />
                </div>
              </div>
            </div>
            {filtroAvanzado ? (
              <div>
                <div className="row container-grid-filtros">
                  <div className="col-12 pb-2">
                    <Form>
                      <Form.Group widths="equal">
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Tipo participante
                          </label>
                          <Select
                            placeholder="Seleccionar..."
                            value={buscarconvocatoria.tipo_participante}
                            options={tiposidentificacion}
                            onChange={(e, { value }) =>
                              cambiarFiltro({
                                e,
                                value,
                                input: "tipo_participante",
                              })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Entidad
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            value={buscarconvocatoria.entidad}
                            placeholder="Seleccionar..."
                            options={EntidadOptions}
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "entidad" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Línea estratégica
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            value={buscarconvocatoria.linea}
                            placeholder="Seleccionar..."
                            options={LineaEstrategicaOptions}
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "linea" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Área
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            placeholder="Seleccionar..."
                            value={buscarconvocatoria.area}
                            options={AreaOptions}
                            label={
                              <label className="font-color-4B4B4B">Área</label>
                            }
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "area" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Año
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            placeholder="Seleccionar..."
                            value={buscarconvocatoria.anio}
                            options={years}
                            label={
                              <label className="font-color-4B4B4B">Área</label>
                            }
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "anio" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Estado
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            placeholder="Seleccionar..."
                            value={buscarconvocatoria.estado}
                            options={EstadosOptions}
                            label={
                              <label className="font-color-4B4B4B">
                                Estado
                              </label>
                            }
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "estado" })
                            }
                          />
                        </Form.Field>
                      </Form.Group>
                    </Form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-end pb-3">
                    <Button
                      className="button-azul-ghost"
                      onClick={limpiarFiltros}
                    >
                      Limpiar filtros
                    </Button>
                    <Button
                      className="button-azul-radius"
                      onClick={filtrarConvocatorias}
                    >
                      Buscar
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="col-12">
              <div className="row">
                <div className="col">
                  <Table
                    style={{ borderTop: "1px solid #C4C4C4" }}
                    locale={{
                      emptyText: (
                        <Empty

                          description="No se han diligenciados datos para está sección"
                          style={{ padding: "50px" }}

                        />
                      ),
                    }}
                    pagination={{
                      position: ["bottomRight"],
                      itemRender: itemRenderTable,
                      pageSize: cantidadPáginas,
                    }}
                    columns={columns}
                    dataSource={datosActuales?.filter(
                      (fila) => !excluirEntidades.includes(fila.entidad)
                    )}
                    scroll={{ x: 1500, y: 300 }}
                    size="small"
                    rowClassName="sizeTable table-row"
                    className="table-ant-design-modify"
                    bordered={false}
                  />
                </div>
              </div>
              {
              user.documento == '1152462177' && (
                  <div className="row">
                    <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                      Todas las entidades{" "}
                      <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828"></span>
                    </div>
                  <div className="col">
                    <Table
                      style={{ borderTop: "1px solid #C4C4C4" }}
                      locale={{
                        emptyText: (
                          <Empty

                            description="No se han diligenciados datos para está sección"
                            style={{ padding: "50px" }}

                          />
                        ),
                      }}
                      pagination={{
                        position: ["bottomRight"],
                        itemRender: itemRenderTable,
                        pageSize: cantidadPáginas,
                      }}
                      columns={columns}
                      dataSource={datosActuales?.filter(
                        (fila) => !eventos.includes(fila.entidad)
                      )}
                      scroll={{ x: 1500, y: 300 }}
                      size="small"
                      rowClassName="sizeTable table-row"
                      className="table-ant-design-modify"
                      bordered={false}
                    />
                  </div>
                </div>
              )}
              {
              (user.documento == '1152462177' || user.documento == '1128439760') && (
                  <div className="row">
                    <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                      Agenda cultural{" "}
                      <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828"></span>
                    </div>
                  <div className="col">
                    <Table
                      style={{ borderTop: "1px solid #C4C4C4" }}
                      locale={{
                        emptyText: (
                          <Empty

                            description="No se han diligenciados datos para está sección"
                            style={{ padding: "50px" }}

                          />
                        ),
                      }}
                      pagination={{
                        position: ["bottomRight"],
                        itemRender: itemRenderTable,
                        pageSize: cantidadPáginas,
                      }}
                      columns={columns}
                      dataSource={datosActuales?.filter(
                        (fila) => eventos.includes(fila.entidad)
                      )}
                      scroll={{ x: 1500, y: 300 }}
                      size="small"
                      rowClassName="sizeTable table-row"
                      className="table-ant-design-modify"
                      bordered={false}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal dimmer={'inverted'} open={openModalBorrar} id="modal_convocatoria" size="small">
        <Modal.Description>
          <div className="container-titulos-modal-actividades">
            <Header className="containar-header-eliminar-adminconvocatoria">
              Eliminar convocatoria
            </Header>
            <Header className="container-subheader-eliminar-adminconvocatoria">
              Esta a punto de eliminar la convocatoria seleccionada
            </Header>
            <Header className="container-subheader-eliminar-adminconvocatoria">
              ¿Desea eliminarla?
            </Header>
            <Header className="container-convocatoria-eliminar-adminconvocatoria">
              {nombreBorrar}
            </Header>
          </div>
        </Modal.Description>
        <Modal.Actions>
          <div className="contenido-acciones-modal-actividades" centered>
            <Button
              className="button-blanco-radius"
              basic
              color="blue"
              onClick={() => setOpenModalBorrar(!openModalBorrar)}
            >
              Cancelar
            </Button>
            <Button
              className="button-azul-radius"
              color="blue"
              onClick={borrarConvocatoria}
            >
              Sí, eliminar
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
      {openModal && (
        <ModalVisualizar
          openModal={openModal}
          setOpenModal={setOpenModal}
          convocatoria={convocatoria}
        />
      )}
    </div>
  );
};
